export default {
  message: '中文简体'
}
